import { useState } from "react";
import { updateUser } from "../../service/subscribers/subscribersApi";
import ModalMessage from "../components/ModalMessage";

const SaveChanges = ({prase, dataToSend, domain, fetchUser}) => {
    const [modal, setModal] = useState(false);
    const [errorModal, setErrorModal] = useState(false);
    
    const stateM = () => {
        setModal(!modal);
    }

    const stateEM = () => {
        setErrorModal(!errorModal);
    }

    async function fillUserInfo() {
        try {
          await updateUser(dataToSend);
          fetchUser();
          stateM();
        } catch (error) {
          console.error('Error updating user:', error);
          stateEM();
        }
      }

    return <p>
      <button className="user-profile-save-btn" onClick={fillUserInfo}>{prase}</button>
      {modal && (
        <ModalMessage
          title="Succsess!"
          message="Changes applied succsessfully"
          actions={<button className="error-btn" onClick={stateM}>Close</button>}
        />
      )}
      {errorModal && (
        <ModalMessage
          title="Error"
          message="Server is not responding"
          actions={<button className="error-btn" onClick={stateEM}>Close</button>}
        />
      )}    
  </p>
}

export default SaveChanges;